$('.hero-cta').each(function () {
    var $this = $(this);
    if ($this.find('.col-lg-6').find('.btn-primary--1, .btn-primary--2, .btn-primary--3, .btn-secondary, .cta-tertiary').length < 2) {
      $this.find('.col-lg-6').css('text-align','center');
    }
  });